import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { wethContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";
import Web3 from "web3";

const BalacefAccountWeth = () => {
  const { account } = useWeb3React();
  // const web3 = useWeb3();
  const web3 = new Web3(Environment.rpc);
  const tokenAddress1 = Environment.weth;
  const contract = wethContract(tokenAddress1, web3);
  const balacefAccountWeth = useCallback(async () => {
    try {
      const buy = await contract.methods.balanceOf(account).call();
      return buy / 10 ** 18;
    } catch (error) {
      throw error;
    }
  }, [contract, account]);
  return { balacefAccountWeth: balacefAccountWeth };
};
export default BalacefAccountWeth;
